/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddSerialNumberPayload,
  MacLookupOnAzure,
} from '../models/index';
import {
    AddSerialNumberPayloadFromJSON,
    AddSerialNumberPayloadToJSON,
    MacLookupOnAzureFromJSON,
    MacLookupOnAzureToJSON,
} from '../models/index';

export interface ApiCompassDevicesAddSerialNumberPostRequest {
    addSerialNumberPayload?: AddSerialNumberPayload;
}

export interface ApiCompassDevicesGetByMacAddressGetRequest {
    macAddress: string;
}

export interface ApiCompassDevicesOverrideSerialNumberPostRequest {
    addSerialNumberPayload?: AddSerialNumberPayload;
}

/**
 * 
 */
export class CompassDevicesApi extends runtime.BaseAPI {

    /**
     */
    async apiCompassDevicesAddSerialNumberPostRaw(requestParameters: ApiCompassDevicesAddSerialNumberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MacLookupOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/CompassDevices/AddSerialNumber`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddSerialNumberPayloadToJSON(requestParameters['addSerialNumberPayload']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MacLookupOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiCompassDevicesAddSerialNumberPost(requestParameters: ApiCompassDevicesAddSerialNumberPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MacLookupOnAzure> {
        const response = await this.apiCompassDevicesAddSerialNumberPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiCompassDevicesGetByMacAddressGetRaw(requestParameters: ApiCompassDevicesGetByMacAddressGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MacLookupOnAzure>> {
        if (requestParameters['macAddress'] == null) {
            throw new runtime.RequiredError(
                'macAddress',
                'Required parameter "macAddress" was null or undefined when calling apiCompassDevicesGetByMacAddressGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['macAddress'] != null) {
            queryParameters['mac_address'] = requestParameters['macAddress'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/CompassDevices/GetByMacAddress`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MacLookupOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiCompassDevicesGetByMacAddressGet(requestParameters: ApiCompassDevicesGetByMacAddressGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MacLookupOnAzure> {
        const response = await this.apiCompassDevicesGetByMacAddressGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiCompassDevicesOverrideSerialNumberPostRaw(requestParameters: ApiCompassDevicesOverrideSerialNumberPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MacLookupOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/CompassDevices/OverrideSerialNumber`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddSerialNumberPayloadToJSON(requestParameters['addSerialNumberPayload']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MacLookupOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiCompassDevicesOverrideSerialNumberPost(requestParameters: ApiCompassDevicesOverrideSerialNumberPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MacLookupOnAzure> {
        const response = await this.apiCompassDevicesOverrideSerialNumberPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
